import { render } from "./FeedbackButton.vue?vue&type=template&id=c31badc6&scoped=true"
import script from "./FeedbackButton.vue?vue&type=script&lang=js"
export * from "./FeedbackButton.vue?vue&type=script&lang=js"

import "./FeedbackButton.vue?vue&type=style&index=0&id=c31badc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c31badc6"]])

export default __exports__